// extracted by mini-css-extract-plugin
export default {"SnackbarItem-variantSuccess":"terms_SnackbarItem-variantSuccess__7Elw+","SnackbarContainer-root":"terms_SnackbarContainer-root__IQMBn","banner_sec":"terms_banner_sec__GP5Ac"};